import * as React from "react";
import classnames from "classnames";
import { Heading } from "@grandvisionhq/elements";
/* empty css                      */
const StoreTileHeading = ({ children, className, ...rest }) => /* @__PURE__ */ React.createElement(Heading, { ...rest, className: classnames("store-tile__typography-heading", className) }, children);
export {
  StoreTileHeading as default
};
//# sourceMappingURL=StoreTileHeading.js.map
